<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb">Talus Mitarbeiter</h3>
                </div>
                <div class="col">
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 250px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables">
                    </el-input>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <el-table type="index"
                      ref="employeeTable"
                      class="table-responsive"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'lastName', order: 'ascending' }"
                      empty-text="Keine Einträge vorhanden"
                      @sort-change="changeSort"
                      :data="filteredEmployees">
                <el-table-column prop="lastName" label="Name" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.lastName) ? row.lastName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="firstName" label="Vorname" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.firstName) ? row.firstName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="shortHand" label="Kürzel" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.shortHand) ? row.shortHand : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="shortScope" label="Bereich" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.shortScope) ? row.shortScope : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="telephone" label="Telefon" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        <a title="Telefon" v-if="row.telephone" :href="'tel:' + row.telephone">{{ row.telephone }}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="telephone2" label="Mobile" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        <a title="Telefon2" v-if="row.telephone2" :href="'tel:' + row.telephone2">{{ row.telephone2 }}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="Email" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        <a title="Email" v-if="row.email" :href="'mailto:' + row.email">{{ row.email }}</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
</template>
<script>
import moment from 'moment';
import UserService from '@/services/user.service';
import BaseAlert from "@/components/BaseAlert";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";

export default {
    name: 'employee-table',
    components: {
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredEmployees() {
            if(this.search === ''){
                this.total = this.employees.length;
                return this.employees.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.employees.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable(){
            this.employees.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getEmployees() {
            UserService.getEmployees().then(
                response => {
                    this.employees = response.data.data;
                    this.sortTable(this.currentSort);
                    this.total = response.data.recordsTotal;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                },
                error => {
                    this.getError(error);
                }
            );
        }
    },
    created() {
        this.getEmployees();
    },
    data() {
        return {
            employees: [],
            currentSort: 'lastName',
            currentSortDir: 'asc',
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            errorText: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 10
        }
    },
    watch: {
        pagination(){
            this.start = (this.pagination - 1) * this.perPage;
        }
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.ck-editor__editable {
    min-height: 150px;
}

.errorText {
    color: #f5365c;
}

thead th {
    cursor: pointer;
}
.el-input__inner {
    border-color: #444444!important;
}
</style>
